import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PrivacyPolicy001 from '../../../../assets/LinkedFieldPrivacyPolicy001.png';
import PrivacyPolicy002 from '../../../../assets/LinkedFieldPrivacyPolicy002.png';
import PrivacyPolicy003 from '../../../../assets/LinkedFieldPrivacyPolicy003.png';
import { HEADER_HIGHT } from '../../../../styles/LayoutSetting';
import {
  BACKGROUND_BLACK,
  BLACK,
  ORANGE,
} from '../../../../styles/Colors';

const useStyles = makeStyles(() => ({
  screenContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: BACKGROUND_BLACK,
    width: '100%',
  },
  rowContainer: {
    marginTop: HEADER_HIGHT,
    width: '100%',
    backgroundColor: ORANGE,
    textAlign: 'center',
  },
  rowText: {
    margin: '40px 0',
    color: BLACK,
    fontSize: 26,
    fontFamily: 'Volkhov',
  },
  imageContainer: {
    width: '80%',
  },
  image: {
    width: '100%',
    objectFit: 'contain',
  },
}));

const Privacy = () => {
  const classes = useStyles();

  return (
    <div className={classes.screenContainer}>
      <div className={classes.rowContainer}>
        <div className={classes.rowText}>
          Privacy Notice
        </div>
      </div>
      <div className={classes.imageContainer}>
        <img
          alt="PrivacyPolicy001"
          src={PrivacyPolicy001}
          className={classes.image}
        />
        <img
          alt="PrivacyPolicy002"
          src={PrivacyPolicy002}
          className={classes.image}
        />
        <img
          alt="PrivacyPolicy003"
          src={PrivacyPolicy003}
          className={classes.image}
        />
      </div>
    </div>
  );
};

export default Privacy;
